import * as types from '../mutation_types';

export default {
  [types.SET_WORKSTATIONS](state, value) {
    state.workstations = value;
  }
}
